//
//
//
//
//
//
//
//
//
//
//
//
//
//
import util from '@/libs/util';
import store from '@/store/index';
export default {
  data: function data() {
    return {
      list: [{
        name: '隐藏表格工具栏',
        command: false
      }, {
        name: '显示表格工具栏',
        command: true
      }],
      isTools: false
    };
  },
  created: function created() {
    var tableTools = util.cookies.get('tableTools');

    if (tableTools === 'true') {
      store.commit('custom/permission/SET_TABLE_TOOLS', true);
      this.isTools = true;
    } else {
      util.cookies.set('tableTools', false);
      this.isTools = store.state.custom.permission.tableTools;
    }
  },
  methods: {
    onChangeTableTools: function onChangeTableTools(val) {
      var tableTools = store.state.custom.permission.tableTools;

      if (tableTools !== val) {
        util.cookies.set('tableTools', val);
        store.commit('custom/permission/SET_TABLE_TOOLS', val);
        this.isTools = val;
        this.$notify({
          title: '表格工具栏变更',
          dangerouslyUseHTMLString: true,
          message: this.isTools ? '当前表格工具栏显示成功' : '当前表格工具栏隐藏成功'
        });
      }
    }
  }
};